import { RadioProps as MuiRadioProps } from '@mui/material/Radio';
import { MuiRadio } from '../../../../../../modules/material';
import {
  StyledRadioControlIcon,
  StyledRadioControlCheckedIcon,
} from './styles';

export interface RadioControlProps extends MuiRadioProps {}

export default function RadioControl(props: RadioControlProps) {
  return (
    <MuiRadio
      checkedIcon={<StyledRadioControlCheckedIcon />}
      icon={<StyledRadioControlIcon />}
      {...props}
    />
  );
}
